module.exports = __webpack_public_path__ + "static/media/documentToken.6d778106.svg";